import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

import { Variable, VariableSummary } from '@mtna/pojo-consumer-ui';

import { RdsChip } from '../../chips/chips.component';

/**
 * Turn `Variable | VariableSummary` into a RdsChip
 * @author Will Davis <will.davis@mtna.us>
 */
@Pipe({
  name: 'rdsVariableToChip',
})
export class RdsVariableToChipPipe<T extends Variable | VariableSummary> implements PipeTransform {
  transform(variable: T): RdsChip {
    if (!variable) {
      return null;
    }
    return new RdsChip(variable.label || variable.name, variable.uri || variable.id);
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [RdsVariableToChipPipe],
  declarations: [RdsVariableToChipPipe],
})
export class RdsVariableChipPipeModule {}
